import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { Gift, ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import { api, errMsg, fmtAZN } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const PromoRedeem = ({ compact, withWallet }) => {
  const { updateUser } = useAuth();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/promo/redeem", { code });
      updateUser({ balance: data.balance });
      toast.success(`Promokod aktivləşdi: +${fmtAZN(data.amount)}`);
      setCode("");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  const form = (
    <form onSubmit={submit} className={`flex flex-1 items-center gap-3 rounded-2xl border border-[#D4AF37]/30 bg-[#111] ${compact ? "p-3" : "p-5"}`} data-testid="promo-redeem-form">
      <Gift className="text-[#D4AF37] shrink-0" size={22} />
      <input className="jp-input !py-2.5 uppercase min-w-0" placeholder="Promokod" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} data-testid="promo-redeem-input" />
      <button disabled={busy} className="btn-gold rounded-full px-5 py-2.5 font-display font-bold text-sm whitespace-nowrap" data-testid="promo-redeem-btn">Aktiv et</button>
    </form>
  );
  if (!withWallet) return form;
  return (
    <div className="flex flex-col md:flex-row gap-3" data-testid="promo-wallet-bar">
      <div className="grid grid-cols-2 gap-3 md:w-auto">
        <Link to="/wallet?tab=deposit" className="btn-gold rounded-2xl px-5 py-3 font-display font-bold text-sm flex items-center justify-center gap-2 whitespace-nowrap" data-testid="quick-deposit-btn"><ArrowDownToLine size={18} />Balans artır</Link>
        <Link to="/wallet?tab=withdraw" className="rounded-2xl px-5 py-3 font-display font-bold text-sm flex items-center justify-center gap-2 whitespace-nowrap border border-[#D4AF37]/50 text-[#D4AF37] bg-[#111] transition-colors hover:bg-[#D4AF37]/10" data-testid="quick-withdraw-btn"><ArrowUpFromLine size={18} />Balans çıxar</Link>
      </div>
      {form}
    </div>
  );
};
